import { computed, type Ref } from 'vue';
import type { PaginationInfo } from '@src/Common/DataGrid/types/paginationInfo.type';

export const ELLIPSIS = '...' as const;
export type PaginationItem = number | typeof ELLIPSIS;

export const usePaginationDisplay = (
    pagination: Ref<PaginationInfo | null | undefined>,
    currentPage: Ref<number>,
    delta = 2,
) => {
    const totalPages = computed((): number => pagination.value?.pages ?? 0);

    const displayedPages = computed((): PaginationItem[] => {
        const total = totalPages.value;
        if (total <= 0) {
            return [];
        }
        if (total === 1) {
            return [1];
        }

        const current = currentPage.value;
        const start = Math.max(1, current - delta);
        const end = Math.min(current + delta, total);

        const pages: PaginationItem[] = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (start > 2) {
            pages.unshift(ELLIPSIS);
            pages.unshift(1);
        } else if (start === 2) {
            pages.unshift(1);
        }

        if (end < total - 1) {
            pages.push(ELLIPSIS);
            pages.push(total);
        } else if (end === total - 1) {
            pages.push(total);
        }

        return pages;
    });

    return { totalPages, displayedPages };
};
